const DEFAULT_LOCALE = "ar-EG";
const ARABIC_AM = "\u0635";
const ARABIC_PM = "\u0645";

export const formatTime12Hour = (timeValue, options = {}) => {
  const { empty = "-", showSeconds } = options;
  if (!timeValue) return empty;

  const value = String(timeValue).trim();
  const match = value.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);

  if (match) {
    const hour24 = Number(match[1]);
    const minute = Number(match[2]);
    const second = match[3];

    if (hour24 >= 0 && hour24 <= 23 && minute >= 0 && minute <= 59) {
      const period = hour24 >= 12 ? ARABIC_PM : ARABIC_AM;
      const hour12 = ((hour24 + 11) % 12) + 1;
      const shouldShowSeconds = showSeconds ?? Boolean(second);
      const secondText = shouldShowSeconds ? `:${second || "00"}` : "";
      return `${hour12}:${String(minute).padStart(2, "0")}${secondText} ${period}`;
    }
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;

  return parsed.toLocaleTimeString(DEFAULT_LOCALE, {
    hour: "2-digit",
    minute: "2-digit",
    second: showSeconds ? "2-digit" : undefined,
    hour12: true,
  });
};

export const formatDateTime12Hour = (dateValue, options = {}) => {
  const { empty = "-", locale = DEFAULT_LOCALE, month = "short" } = options;
  if (!dateValue) return empty;

  const parsed = new Date(dateValue);
  if (Number.isNaN(parsed.getTime())) return String(dateValue);

  return parsed.toLocaleString(locale, {
    year: "numeric",
    month,
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
